export const ROOT_URL = process.env.NEXT_PUBLIC_URL;
export const ROOT_API_URL = process.env.NEXT_PUBLIC_API_URL;
export const API_SERVICE_TOKEN = process.env.NEXT_PUBLIC_API_SERVICE_TOKEN;
export const AUTH_MARKER = process.env.NEXT_PUBLIC_AUTH_MARKER;
export const COOKIE_DOMAIN = process.env.NEXT_PUBLIC_COOKIE_DOMAIN;
export const ROOT_WWW_URL = process.env.NEXT_PUBLIC_WWW_URL;
export const ROOT_PRIORITY_URL = process.env.NEXT_PUBLIC_PRIORITY_URL;
